/**
 * Used layout from SettingsFormatSetupViewController
 */

class KitchenOrderSetupViewController extends SingleEditViewController
{
    static newInstance() : KitchenOrderSetupViewController {
        let vc = new KitchenOrderSetupViewController("single-edit-view");
        vc.initWithResource("layout/base/SingleEditView.html");
        return vc;
    }

    get title(){
        return MIOLocalizeString("KITCHEN_ORDER", "KITCHEN ORDER");
    }

    fetchEntity(){
        return "CategoryTag";
    }

    configureCellAtIndexPath(cell:SingleEditCell, indexPath:MIOIndexPath, item:MIOManagedObject){
        let d = item as CategoryTag;
        cell.setItem(d, "name");
    }

    addButtonDidPress(){

        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("NEW_CATEGORY_TAG", "NEW CATEGORY TAG"), MIOLocalizeString("CHOOSE_A_NAME", "CHOOSE A NAME"), MUIAlertViewStyle.Default);
        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
            textField.setPlaceholderText(MIOLocalizeString("NAME","NAME"));
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('ADD','ADD'), MUIAlertActionStyle.Default, this, function(){
            let nameTF =  avc.textFields[0];
            let name = nameTF.text.trim();

            if(name.length > 0){
                let moc = MUIWebApplication.sharedInstance().delegate.managedObjectContext;
                var categoryTag = MIOEntityDescription.insertNewObjectForEntityForName("CategoryTag", moc) as CategoryTag;
                categoryTag.identifier = MIOUUID.UUID().UUIDString;
                categoryTag.name = name;
                moc.save();
            }
            else {
                let error = new MUIAlertViewController();
                error.initWithTitle(MIOLocalizeString('ERROR', 'ERROR'), MIOLocalizeString("CHECK_NAME", "CHECK NAME"), MUIAlertViewStyle.Default);
                error.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CLOSE','CLOSE'), MUIAlertActionStyle.Cancel, this, function(){}));
                
                this.presentViewController(error, true);
            }
        }));
        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CANCEL','Cancel'), MUIAlertActionStyle.Cancel, this, function(){}));
        
        this.presentViewController(avc, true);
    }
    
}
